"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
exports.ScrollToTop = function () {
    var _a = react_router_dom_1.useLocation(), pathname = _a.pathname, search = _a.search;
    // just run the effect on pathname and/or search change
    react_1.useEffect(function () {
        try {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        }
        catch (error) {
            // just a fallback for older browsers
            window.scrollTo(0, 0);
        }
    }, [pathname, search]);
    // renders nothing, since nothing is needed
    return null;
};
//# sourceMappingURL=ScrollToTop.js.map